import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initFirebase } from '@flowfocus/core';
import App from './App';
import './styles/global.css';

initFirebase();

// The old service worker cached every Firestore request here and never reused it: free the space.
if ('caches' in window) void caches.delete('firebase-cache').catch(() => {});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
